import { render, staticRenderFns } from "./GroupForm.vue?vue&type=template&id=d6ec9c52&scoped=true"
import script from "./GroupForm.ts?vue&type=script&lang=ts&external"
export * from "./GroupForm.ts?vue&type=script&lang=ts&external"
import style0 from "./GroupForm.vue?vue&type=style&index=0&id=d6ec9c52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ec9c52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6ec9c52')) {
      api.createRecord('d6ec9c52', component.options)
    } else {
      api.reload('d6ec9c52', component.options)
    }
    module.hot.accept("./GroupForm.vue?vue&type=template&id=d6ec9c52&scoped=true", function () {
      api.rerender('d6ec9c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/forms/GroupForm/GroupForm.vue"
export default component.exports